<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.userNum')}}</span>
        </div>
        <input class="e-input" :value='userNum' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox" style="height: 420px">
      <div class="h-dialog-borderBox-topIcon" style="padding: 0px;">

        <input class="e-input" type="text" v-model='searchNum' style="width: 200px;margin:5px 5px 5px 15px">
        <button :title='$t("MCS.superSearch")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='searchGridData' data-ripple="true" tabindex="-1">
        </button>

        <button :title='$t("MCS.add")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-add-small" data-ripple="true" tabindex="-1" @click='addBlack' style="margin: 5px 10px 5px 5px;float: right">
        </button>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true':pageSettings="pageSettings">
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='30' textAlign='Center'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' headerText='MC-ID' width='150' textAlign='Center'></e-column>
            <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div>
      <!--<ejs-pager @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ref='pager'></ejs-pager>-->
      <ejs-pager @click='getGridData()' :pageSize="pageSettings.pageSize" :pageCount="pageCount" ref='pager'></ejs-pager>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import commonJS from '../../common';
import DialogList from '../../../../subscriberconfig/util/tipDialog/DialogList';
import CustomDialog from '../../../../common/CustomDialog';
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'AddBlackDialog',
  props: [
    'neid',
    'vpnId',
    'vpnClass'
  ],
  components: {
    DialogList,
    CustomDialog
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      userNum: '',
      mcsid: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      searchNum: '',
      pageSettings: { pageSize: 100 },
      pageCount: 4,
      vo: {
        flag: '',
        participantType: ''
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.confirm') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {

    searchGridData() {
      const $this = this;
      const vo = {
        flag: 2,
        userNum: $this.searchNum,
        userType: 0,
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        vpnId: 0,
        vpnClass: 0,
      };
      const params = {
        info: {
          neid: $this.neid,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: 1,// 搜索默认返回第一页内容
          //pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$refs.pager.ej2Instances.goToPage(1);

      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        // $this.page.totalCount = res.totalCnt;
        $this.$refs.pager.ej2Instances.totalRecordsCount = res.totalCnt;
      });
    },


    getGridData(userNum = this.userNum) {
      const $this = this;
      this.userNum = userNum;
      const vo = {
        flag: 2,
        // userNum: '',
        userNum: $this.searchNum,
        userType: 0,
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        vpnId: 0,
        vpnClass: 0,
        // vpnId: $this.vpnId,
        // vpnClass: $this.vpnClass,
      };
      const params = {
        info: {
          neid: $this.neid,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        // $this.page.totalCount = res.totalCnt;
        $this.$refs.pager.ej2Instances.totalRecordsCount = res.totalCnt;
      });
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    getGridMCID() {
      const gridData = this.$refs.grid.getSelectedRecords();
      if (gridData.length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return null;
      };
      const mcsid = [];
      gridData.forEach((item) => {
        mcsid.push(item.mcsid);
      });
      return mcsid;
    },

    getGridMCName() {
      const gridData = this.$refs.grid.getSelectedRecords();
      if (gridData.length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return null;
      };
      const userNum = [];
      gridData.forEach((item) => {
        userNum.push(item.userNum);
      });
      return userNum;
    },

    addBlack() {
      const $this = this;
      const blackNum = this.getGridMCName();
      if (blackNum === null) return;
      const userNum = [];
      this.$refs.grid.getSelectedRecords().forEach((item) => {
        userNum.push(item.userNum);
      });
      const logArray = [];
      userNum.forEach((numItem) => {
        logArray.push({
          userNum: $this.userNum,
          blackNum: numItem
        });
      });
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.addBlackList,
          operation: 'addBlackNum'
        },
        vo: {
          0: {
            vo: {
              enterpriseDomain: $this.enterpriseDomain,
              productType: $this.productType,
              userNum: $this.userNum,
              blackNum: blackNum
            },
            info: {
              neid: this.neid,
              msgid: this.msg.addBlackList,
              mcsFlag: true
            },
          }
        },
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
          execFunName: 'subscriber.mcsAddBlack',
          exectype: 1,
          execData: logArray
        }
      };
      const opCount = blackNum.length;
      const resObj = [];
      for (let i = 0; i < opCount; i++) {
        const resData = {};
        resData.operObj = blackNum[i];
        resObj.push(resData);
      }
      EventBus.$emit('loading', { ison: true });
      this.$axios.post(this.requestCommon, params).then((response) => {
        EventBus.$emit('loading', { ison: false });
        resObj.forEach((item, index) => {
          item.operResult = parseInt(response.data.resultVal[index].code) === 0 ? $this.$t('Common.tips.success') : response.data.resultVal[index].code;
          item.operCode = response.data.resultVal[index].code;
        });
        this.$refs.dialog.addOperetionResultList(resObj);
        this.$refs.dialog.setTotalCount(opCount);
        this.$refs.dialogPage.show();
      });
    },
  },
};
</script>

<style scoped>
  .my-class.e-btn:active,.my-class.e-btn:focus{
    box-shadow: none !important;
  }

  .my-class{
    width: 30px;
    height: 30px;
    padding: 0px;
    color: #007bff;
    background-color: #e6f7ff;
    border: 0px;
  }
</style>
